/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_No_ShowInputs */

const en_status_no_show = /** @type {(inputs: Status_No_ShowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`no show`)
};

const he_status_no_show = /** @type {(inputs: Status_No_ShowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`לא הגיע`)
};

/**
* | output |
* | --- |
* | "no show" |
*
* @param {Status_No_ShowInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const status_no_show = /** @type {((inputs?: Status_No_ShowInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_No_ShowInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_status_no_show(inputs)
	return he_status_no_show(inputs)
});